<div class="">
  @if (group.name != "") {
    <div class="sm:flex sm:items-center mb-4">
      <div class="sm:flex-auto">
        <h1 class="text-base font-semibold text-gray-900">{{ group.name }}</h1>
      </div>
    </div>
  }
  <div class="flow-root">
    <div class="overflow-x-auto">
      <div class="inline-block min-w-full align-middle">
        <table class="min-w-full divide-y divide-gray-300">
          <thead>
          <tr>
            <th scope="col" class="py-2 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8">
              Item
            </th>
            <th scope="col" class="px-3 py-2 text-left text-sm font-semibold text-gray-900">Menge</th>
            <th scope="col" class="px-3 py-2 text-left text-sm font-semibold text-gray-900">Preiseinfluss</th>
          </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white">
            @for (component of components; track component.id) {
              <tr>
                <td class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                  {{ component.component.itemName }}
                </td>
                <td
                  class="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                  {{ component.component.value | number: "1.0-2" }} {{ component.component.unit ? "Einheit(en)" : UnitLabels[component.component.itemUnit] }}
                </td>
                <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                  @if (component.priceChange != undefined && component.priceChange != 0) {
                    {{ component.priceChange > 0 ? "+" : "" }}{{ component.priceChange | currency: "EUR" }}
                  } @else {
                    -
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

